// 维修相关API接口
import request from '@/utils/request'
/**
 *
 * @param type
 * @returns {*}
 */
export function replyconfigGet(type) {
    return request({
        url: '/replyconfig/getByType/'+type,
        method: 'get'
    })
}
/**
 * 维修差评自动回复配置
 * @param data
 * @returns {*}
 */
export function repairReplySet(data) {
    return request({
        url: '/replyconfig/updateR',
        method: 'put',
        data
    })
}
/**
 * 工单差评自动回复配置
 * @param data
 * @returns {*}
 */
export function workReplySet(data) {
    return request({
        url: '/replyconfig/updateW',
        method: 'put',
        data
    })
}

/**
 * 维修单、工单差评自动回复配置
 * @param data
 * @returns {*}
 */
export function replySet(data) {
    return request({
        url: '/replyconfig/updateConfig',
        method: 'put',
        data
    })
}
